import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { CommentaireResponseDto } from 'lib_api/lib/api/gen';

import { sortCommentaireListDtoByDateDesc } from 'utils/commentaireUtils';

import { useApi } from '../ApiStoreContext';
import { useHandleBackErrors } from '../utils/handleBackErrors';

export function useCommentaires(
  dossierId?: string,
): UseQueryResult<CommentaireResponseDto[]> {
  const { CommentaireControllerApi } = useApi();
  const behaviourOnError = useHandleBackErrors();

  function fetchCommentaires(): Promise<CommentaireResponseDto[]> {
    if (!dossierId) {
      return Promise.resolve([]);
    }
    return CommentaireControllerApi.getCommentairesUsingGET(dossierId)
      .then(response => sortCommentaireListDtoByDateDesc(response))
      .catch((error: Response) => {
        behaviourOnError(error);
        return [];
      });
  }

  return useQuery({
    queryKey: ['commentaires', dossierId],
    queryFn: fetchCommentaires,
  });
}
